import { registerFeature } from "lib/features"
import { FEATURE_FLAG_REGIME_DRAFT_LOCKING } from "./server/feature-flag-regime-draft-locking.mjs"
import {
    PublishingStepsBelow,
    ScheduleSelectorWrapper,
    SelectorTitleExtras,
    SelectorTitleRight,
} from "slot-definitions"
import { RegimeDraftLock } from "./regime-draft-lock"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { TailoringInReviewButton } from "./tailoring-in-review-button"
import { RegimeDraftLockBanner } from "./regime-draft-lock-banner"
import { RegimeDraftPublishedDate } from "./regime-draft-published-date"
import { InReviewLabel } from "./in-review-label"

registerFeature({
    numericalId: 19,
    name: "Regime Draft Locking",
    id: FEATURE_FLAG_REGIME_DRAFT_LOCKING,
    description: `Enables the locking of a regime's draft when the regime is in review.`,
    readyForProduction: true,
})

ScheduleSelectorWrapper.plug(<RegimeDraftLock />)

SelectorTitleRight.plug(
    <Secure demand="manageRegime" fallback={<Frag />} priority={200}>
        <TailoringInReviewButton />
    </Secure>
)

SelectorTitleRight.plug(
    <Secure demand="manageRegime" fallback={<Frag />} priority={100}>
        <RegimeDraftPublishedDate />
    </Secure>
)

PublishingStepsBelow.plug(<RegimeDraftLockBanner />)

SelectorTitleExtras.plug(<InReviewLabel priority={300} />)
